import { MaxContentWidth } from '@components'

interface EventBodyWrapperProps {
  children: React.ReactNode
}

export const EventBodyWrapper = ({ children }: EventBodyWrapperProps) => {
  return <MaxContentWidth>{children}</MaxContentWidth>
}
